import { useEffect, useRef } from 'react';
import { useLaMevaLlista } from 'hooks/3catinfo/useLaMevaLlista';
import styles from './stickyFooter.module.scss';
import Boto from '../../Boto/Boto';
import clsx from 'clsx';

const StickyFooter = (props) => {
    const { tipologia, onUpdate, onCancel, isOnModal, setHaCanviat, estil } = props;
    const { itemsLaMevaLlista, itemsLaMevaLlistaCloneRef, loaded, stickyVisible, setStickyVisible } = useLaMevaLlista();
    const contentRef = useRef(null);

    const arraysAreEqualUnordered = (a = [], b = []) => {
        if (a.length !== b.length) return false;
        const sortedA = [...a].sort((x, y) => x - y);
        const sortedB = [...b].sort((x, y) => x - y);
        return sortedA.every((val, index) => val === sortedB[index]);
    };

    useEffect(() => {
        if (!loaded) return;
        const actuals = itemsLaMevaLlista[tipologia] || [];
        const clonats = itemsLaMevaLlistaCloneRef.current[tipologia] || [];
        const haCanviat = !arraysAreEqualUnordered(actuals, clonats);
        setHaCanviat?.(haCanviat);
        setStickyVisible(haCanviat);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsLaMevaLlista, loaded, itemsLaMevaLlistaCloneRef]);

    const contentHeaderClass = clsx(isOnModal ? styles.contentHeaderModal : styles.contentHeader);

    const handleUpdateClick = () => {
        onUpdate((prev) => prev + 1);
        setStickyVisible(false);
    };

    const handleCancellaClick = () => {
        onCancel();
    };

    const stylesSticky = clsx({
        [styles.stickyFooter]: true,
        [styles[estil]]: !!estil
    });

    return (
        <>
            {stickyVisible && (
                <div className={stylesSticky} ref={contentRef} data-testid='item-noti-sticky'>
                    <div className={contentHeaderClass}>
                        <div className={styles.innerHeader}>
                            <Boto
                                tag='button'
                                text='Cancel·la'
                                estil='lined'
                                iconaInline={true}
                                altIcona='Cancel·la'
                                dataTestId='areausuaris-cancella'
                                className={styles.botoCancella}
                                onClick={handleCancellaClick}
                            />
                            <Boto
                                tag='button'
                                text='Desa els canvis'
                                estil='lined'
                                iconaInline={true}
                                altIcona='Desa els canvis'
                                dataTestId='areausuaris-desa-els-canvis'
                                className={styles.botoDesaCanvis}
                                onClick={handleUpdateClick}
                            />
                        </div>
                    </div>
                    <div className={styles.contentMeu3cat}>{props.children}</div>
                </div>
            )}
        </>
    );
};

export default StickyFooter;
